module.exports = __webpack_public_path__ + "img/570f2db.png";